var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notes)?_c('div',[_c('h4',[_vm._v("Hinweis")]),_c('div',{domProps:{"textContent":_vm._s(_vm.notes)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }